import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "all" }
const _hoisted_2 = { class: "master" }
const _hoisted_3 = { class: "float-L" }
const _hoisted_4 = { class: "header-css" }

import headmenu from "../inc/webheader.vue";

import store from "../store";
import { onMounted, reactive, ref } from "vue";
import {
  getvisitornum,
  weblogout,
} from "../request/userlist";
import { useRouter } from "vue-router";
import weblogin1 from "@/components/weblogin.vue";
import register1 from "@/components/register.vue";
import setpassword from "@/components/setpassword.vue";
//import { watch } from "node:fs/promises";




export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

const visitor = ref(0);
const showfindpassword = ref(false);
const showlogin = ref(false);
const showregist = ref(false);

const sign = () => {
  showlogin.value = true;
};
const VIPsign = () => {
  let token = localStorage.getItem("token");

  if (!token) {

    exit()
  }
  else
    router.push("/VIPhome");
};
const exit = () => {
  weblogout().then(() => { });
  localStorage.clear();

  store.commit("resetStore");

  //showlogin.value=true
  router.push("/about");
};
const register = () => {
  showregist.value = true;
};
const resetpassword = () => {
  showfindpassword.value = true;
};
const registerForm = reactive({
  userid: "",
  userpw: "",
  name: "",
  checkuserpw: "",
});
const router = useRouter(); //-->$router

//const store = useStore();
onMounted(() => {
  let token = localStorage.getItem("token");
 
  if (!token) {
   
    exit()
  }
  getvisitornum()
    .then((res) => {
      if (res.data.code == 401) {
        localStorage.clear();
        getvisitornum().then((res) => {
          visitor.value = res.data.data;
        });
      } else {
        visitor.value = res.data.data;
      }
    })
    .catch(() => {
      localStorage.clear();
      getvisitornum().then((res) => {
        visitor.value = res.data.data;
      });
    });


});
const clickEven = (val: any) => {
  showlogin.value = false;


  if (val.typeid == 2) {
    showregist.value = true;
  }
  if (val.typeid == 3) {
    showfindpassword.value = true;
  }
};

const clickEven2 = (val: any) => {

  showregist.value = false;
  if (val.typeid == 1) showlogin.value = true;

};
const clickEven1 = () => {
  showfindpassword.value = false;

};

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                class: "welcome",
                span: 14,
                offset: 1
              }, {
                default: _withCtx(() => [
                  _createElementVNode("label", null, "欢 迎 ! 您 是 第 " + _toDisplayString(visitor.value) + " 位 访 客", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                class: "welcome",
                align: "right",
                span: 8
              }, {
                default: _withCtx(() => [
                  (_ctx.$store.state.name.length == 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        Default: "",
                        text: "",
                        onClick: resetpassword
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("忘记密码", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.$store.state.name.length > 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        Default: "",
                        text: "",
                        style: {"color":"red"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$store.state.name), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.$store.state.name.length == 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        Default: "",
                        text: "",
                        onClick: register
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("注册", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.$store.state.name.length == 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 3,
                        Default: "",
                        text: "",
                        onClick: sign
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("登录", -1)
                        ]))]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 4,
                        Default: "",
                        text: "",
                        onClick: exit
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("退出登录 ", -1)
                        ]))]),
                        _: 1
                      })),
                  (_ctx.$store.state.vip)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 5,
                        Default: "",
                        text: "",
                        onClick: VIPsign
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("VIP用户", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(headmenu)
        ]),
        _createVNode(_component_router_view),
        _createVNode(headmenu),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { class: "row-12" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("版权所有 南京敏思软件有限公司", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" 电话:025-86649490 传真:025-84403315 邮编:210000", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("苏ICP备16003457号-1", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_dialog, {
      width: "30%",
      "show-close": false,
      modelValue: showlogin.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showlogin).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(weblogin1, { onClickChild: clickEven })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "30%",
      "show-close": false,
      modelValue: showfindpassword.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showfindpassword).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(setpassword, { onClickChild: clickEven1 })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "30%",
      "show-close": false,
      modelValue: showregist.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showregist).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(register1, { onClickChild: clickEven2 })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})